import { FormGroup } from "../../../components/form";
import * as Yup from "yup";

export const childSearchForm: FormGroup = {
  type: "formGroup",
  classNameOpt: "child-search-form",
  fields: [
    {
      type: "field",
      fieldType: "advisory",
      key: "advisory",
      props: {
        styleClasses: "flex font-bold",
        Body: () => (
          <div className="float-left">
            <p>Search Parameters:</p>
          </div>
        ),
      },
    },
    {
      type: "field",
      fieldType: "advisory",
      key: "advisory",
      props: {
        type: "fieldadv",

        styleClasses: "",
        Body: () => (
          <div className="float-left">
            <p>Select which combination of inputs to include in the search</p>
          </div>
        ),
      },
    },
    {
      type: "formGroup",

      fields: [
        {
          type: "field",
          key: "firstNameCheck",
          fieldType: "checkbox",
          label: "First Name",
          defaultValue: true,
        },
        {
          type: "field",
          key: "lastNameCheck",
          fieldType: "checkbox",
          label: "Last Name",
          defaultValue: true,
        },
        {
          type: "field",
          key: "dateOfBirthCheck",
          fieldType: "checkbox",
          label: "DOB",
          defaultValue: true,
          validation: Yup.boolean().when(["firstNameCheck", "lastNameCheck"], ([firstNameCheck, lastNameCheck], schema) => {
            if (!firstNameCheck && !lastNameCheck) {
              return schema.oneOf([true], "Please select at least one search parameter to check");
            }
            return schema;
          }),
        },
      ],
    },
    {
      type: "field",
      key: "firstName",
      fieldType: "input",
      props: {
        placeholder: "First Name",
      },
      validation: Yup.string().when(["firstNameCheck"], ([firstNameCheck], schema) => {
        if (firstNameCheck) {
          return schema.required("Please enter a Child's given name to search for");
        }
        return schema.notRequired();
      }),
    },
    {
      type: "field",
      key: "lastName",
      fieldType: "input",
      props: {
        placeholder: "Last Name",
      },
      validation: Yup.string().when(["lastNameCheck"], ([lastNameCheck], schema) => {
        if (lastNameCheck) {
          return schema.required("Please enter a Child's family name to search for");
        }
        return schema.notRequired();
      }),
    },
    {
      type: "field",
      key: "dateOfBirth",
      fieldType: "calendar",
      props: {
        placeholder: "DOB",
        panelClassName: "childchecker-datepicker",
      },
      validation: Yup.string().when(["dateOfBirthCheck"], ([dateOfBirthCheck], schema) => {
        if (dateOfBirthCheck) {
          return schema.required("Please enter a date of birth to search for");
        }
        return schema.notRequired();
      }),
    },
    {
      type: "field",
      fieldType: "advisory",
      key: "advisory",
      props: {
        type: "fieldadv",

        styleClasses: "flex flex-col items-start",
        Body: () => (
          <div className="float-left">
            <p>Enter a child's first name, last name, and date of birth to check</p>
          </div>
        ),
      },
    },
  ],
};
